export const helpKey = 'A430538626294D82A5F51FF2B8AAF2FA';
export const supportKey = 'A430538626294D82A5F51FF2B8AAF2FA';
